import PropTypes from 'prop-types'
import { useState } from 'react'

import { FormModal, Snackbar } from '../../default'
import { CreateAccessKeyForm } from '../../forms'

/**
 * @description Renders a modal for creating a key manager.
 * 
 * @author Maria Eduarda Franke
 * @param {boolean} open - Determines whether the modal is open or not.
 * @param {function} onClose - Callback function to close the modal.
 * @returns {JSX.Element} - Returns the JSX element representing the CreateKeyManagerModal component.
 */
const CreateKeyManagerModal = ({ open, onClose }) => {

    const [showSnackbar, setShowSnackbar] = useState(false)

    const handleSnackbarClose = (_, reason) => {
        if (reason === 'clickaway') {
            return
        }
        setShowSnackbar(false)
    }

    return (
        <>
            <FormModal
                title='Criar Chave de Acesso'
                open={open} onClose={onClose}
            >
                <CreateAccessKeyForm onClose={onClose} setShowSnackbar={setShowSnackbar} />
            </FormModal>
            <Snackbar
                open={showSnackbar}
                onClose={handleSnackbarClose}
                vertical='bottom'
                horizontal='right'
                severity='success'
                variant='filled'
                message='Nova chave de acesso criada com sucesso!'
                sx={{ mt: 1 }}
            />
        </>
    )

}

CreateKeyManagerModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired
}

export default CreateKeyManagerModal